import { inject, Injectable } from '@angular/core';

import { ItemWithCompanyId } from '../../helpers/co-browsing-filter';
import {
  ItemWithServiceInfo,
  shouldIncludeItemByEnabledServices,
} from '../../helpers/service-filter';
import { CoBrowsingFilterService } from '../co-browsing';

@Injectable({
  providedIn: 'root',
})
export class ServiceFilterService {
  private coBrowsingFilterService = inject(CoBrowsingFilterService);

  createServiceFilter(
    enabledServiceIds: number[] | null,
  ): (item: ItemWithServiceInfo) => boolean {
    return (item: ItemWithServiceInfo) =>
      shouldIncludeItemByEnabledServices(item, enabledServiceIds);
  }

  createCoBrowsingAndServiceFilter<
    T extends ItemWithCompanyId & ItemWithServiceInfo,
  >(
    userAccessType: string | null | undefined,
    isRestrictedRole: (accessType?: string | null) => boolean,
    enabledServiceIds: number[] | null,
  ): (item: T) => boolean {
    const coBrowsingFilter = this.coBrowsingFilterService.createFilter(
      userAccessType,
      isRestrictedRole,
    );
    const serviceFilter = this.createServiceFilter(enabledServiceIds);

    return (item: T) => coBrowsingFilter(item) && serviceFilter(item);
  }
}
